import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AuthService } from '../../shared/src/lib/services/auth/auth.service';
import { APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  HttpClient,
} from '@angular/common/http';
import { JwtInterceptor } from '../../shared/src/lib/utils/interceptors/jwt.interceptor';
import {
  ErrorInterceptor,
  LoadingIndicatorInterceptor,
  AppLayoutModule,
  TalkjsChatComponent,
} from 'shared';
import { AppRoutingModule } from './app/app-routing.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpLoaderFactory } from '../../shared/src/lib/translate.loader';
import { ClaimsRoutingModule } from './app/pages/claims/claims-routing.module';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';

function appInitializer(authService: AuthService) {
  return () => {
    return new Promise((resolve) => {
      // @ts-ignore
      if (authService.isAuthenticated()) {
        resolve(true);
        // console.log('Authenticated');
      } else {
        // console.log('Not Authenticated');
        resolve(false);
        authService.logout();
      }
    });
  };
}

bootstrapApplication(AppComponent, {
  providers: [
    provideAnimations(),
    importProvidersFrom(
      AppRoutingModule,
      // AppLayoutModule,
      // TalkjsChatComponent,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
      // ClaimsRoutingModule
    ),
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    // EventService,
    AuthService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService],
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingIndicatorInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
}).catch((err) => console.error(err));
